export const translation = {
  'pl': {
    buoyName: 'Boja Borucino',
    temp: 'Temp',
    tempLong: 'Temp wody',
    airTemp: 'Temp powietrza',
    do: 'Tlen',
    turbidity: 'Mętność',
    ec: 'Przewodność',
    ecLong: 'Przewodność / Zasolenie',
    exampleData: 'Przykładowe dane z boji na Jeziorze Raduńskim Grn.',
    mobileMonitoring: 'Usługę monitoringu jakości wody dostarcza firma Mobile Monitoring Sp.z o.o.'
  },
  'en': {
    buoyName: 'Borucino Lake Buoy',
    temp: 'Temp',
    tempLong: 'Water Temperature',
    airTemp: 'Air Temperature',
    do: 'Oxygen',
    turbidity: 'Turbidity',
    ec: 'Conductivity',
    ecLong: 'Conductivity / Salinity',
    exampleData: 'Example data from buoy on Jeziorze Raduńskie Grn.',
    mobileMonitoring: 'The water quality monitoring service is provided by Mobile Monitoring'
  }
};
